// extracted by mini-css-extract-plugin
export var infoItem = "_tp-2";
export var title = "_tp-0";
export var value = "_tp-1";